module.exports = __webpack_public_path__ + "mw.4ca3522bbf8126269031.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/mw.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/mw.svg
// module chunks = styles